import element from 'element-ui';

export default {

// 复制成功
  onCopy: function() {
    element.Message.success('复制成功！');
  },

// 复制失败
  onError: function() {
    element.Message.error('复制失败，请重试！');
  }

};
